<template>
    <div>
        <ModalBase :show-modal="showModal" @close-modal="close" :narrow="true" :auto-h="true" :overlay-scrollb="false">
            <template v-slot:titlebar>
                <TitleBar variant-class="title-modal">
                    <template v-slot:pretitle>
                        {{ (isEdit) ? $gettext('EDIT'): $gettext('ADD') }}
                    </template>
                    <template v-slot:title>
                        <span v-if="isEdit" v-translate>Investment item</span>
                        <span v-if="!isEdit" v-translate>Investment item</span>
                    </template>
                </TitleBar>
            </template>
            <template v-slot:maincontent>
                <AddEditItem @edited="onItemEdited" @created="onItemCreated" ref="addedititem" />
            </template>
            <template v-slot:actions>
                <GekkoButton 
                    v-if="$route.params['investmentId']"
                    :text="$gettext('Delete')" 
                    icon="fa-solid fa-trash-can"
                    class="text-danger"
                    variant="link"
                    size="sm"
                    v-gk-confirm="{
                        title: $gettext('Delete investment'),
                        message: $gettext('Are you sure you want to delete this investment?'),
                        options: {
                            variant: 'danger',
                            confirmText: $gettext('Delete')
                        },
                        callback: itemDeleted
                    }"
                />
                <GekkoButton 
                    @click="$refs.addedititem.saveForm()"
                    :text="$gettext('Save Item')" 
                    icon="fa-solid fa-floppy-disk"
                    class="float-right position-relative"
                    type="submit"
                    size="sm"
                    :loading="isWaitingForResponse"
                />
            </template>
        </ModalBase>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TitleBar from "@/components/TitleBar";
import ModalBase from "@/components/base_components/ModalBase";
import AddEditItem from "@/components/balance_sheet/AddEditItem";
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "ItemModal",
    components: {TitleBar, ModalBase, AddEditItem, GekkoButton},
    props: {
        showModalOn: {
            type: Array
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.showModal = this.showModalOn.includes(to.name);
                (this.showModal) ? document.body.classList.add('modal-on') : document.body.classList.remove('modal-on');
            }
        }
    },
    data() {
        return {
            showModal: false
        }
    },
    created() {
        window.addEventListener('keydown', this.closeEventListener);
    },
    destroyed() {
        window.removeEventListener('keydown', this.closeEventListener);
    },
    methods: {
        closeEventListener(event) {
            if (this.showModal && event.key === 'Escape') this.close();
        },
        close() {
            this.$router.push({name: 'BalanceSheet'});
        },
        onItemEdited(item) {
            this.$emit("edited", item);
            this.close();
        },
        onItemCreated(item) {
            this.$emit("created", item);
            this.close();
        },
        itemDeleted() {
            this.$emit("deleted", this.$refs.addedititem.item);
            this.close();
        }
    },
    computed: {
        ...mapGetters({
            isWaitingForResponse: 'main/isWaitingForResponse'
        }),
        isEdit() {
            if (this.$route.params['investmentId'])
                return true;
            else
                return false;
        }
    }

}
</script>

<style lang="scss">

</style>